import { Component } from '@angular/core';

@Component({
  selector: 'app-producao',
  templateUrl: './producao.component.html',
  styleUrl: './producao.component.css'
})
export class ProducaoComponent {

}
